<div class="flex flex-wrap -mx-2">
	<div class="flex-none w-5/12 px-2">
		<mat-form-field id="cron-job-frequency" appearance="outline" class="mb-2 w-full">
			<mat-label>Frequency:</mat-label>
			<mat-select name="cron-job-frequency" [formControl]="selectedFrequencyControl" #siSelectRef="matSelect">
				<mat-option *ngIf="!config?.hideDaily" [value]="frequencyTypesEnum.DAILY">Daily</mat-option>
				<mat-option *ngIf="!config?.hideWeekly" [value]="frequencyTypesEnum.WEEKLY">Weekly</mat-option>
				<mat-option *ngIf="!config?.hideMonthly" [value]="frequencyTypesEnum.MONTHLY">Monthly</mat-option>
			</mat-select>
			<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
		</mat-form-field>
	</div>
	<div class="flex-none w-1/4 px-2">
		<div class="flex flex-wrap -mx-2 gap-0" *ngIf="selectedFrequencyControl.value" [formGroup]="form">
			<div class="flex-none w-1/2 pr-2">
				<mat-form-field appearance="outline" class="w-full daily-selector">
					<mat-label>Timing</mat-label>
					<mat-select [formControlName]="formKeysEnum.Hours" [panelWidth]="'90px'" #siSelectRef2="matSelect">
						<mat-option *ngFor="let hour of hoursOptions" [value]="hour">{{ hour }}:00</mat-option>
					</mat-select>
					<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef2.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
				</mat-form-field>
			</div>

			<div class="flex-none w-1/2 pl-2">
				<mat-form-field appearance="outline" class="w-full daily-selector">
					<mat-select [formControlName]="formKeysEnum.Ampm" [panelWidth]="'90px'" #siSelectRef3="matSelect">
						<mat-option *ngFor="let ampm of ampmOptions" [value]="ampm">{{ ampm }}</mat-option>
					</mat-select>
					<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef3.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="grow shrink-0 basis-0 px-2">
		<button class="mat-error" matButton="filled" (click)="clearSchedule(true)">Clear Schedule</button>
	</div>
</div>
<div class="flex flex-wrap -mx-2" [formGroup]="form">
	<div class="flex-none w-full mt-2 px-2" *ngIf="selectedFrequencyControl.value === frequencyTypesEnum.MONTHLY">
		<div class="flex items-center">
			<span>on day</span>
			<div class="inline-block truncate mx-2">
				<mat-form-field appearance="outline" class="mb-2 w-full gap-0">
					<mat-select [formControlName]="formKeysEnum.MonthDay" #siSelectRef4="matSelect">
						<mat-option *ngFor="let day of monthDaysOptions" [value]="day.value">{{ day.description }}</mat-option>
					</mat-select>
					<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef4.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
				</mat-form-field>
			</div>
			<span>of the month</span>
		</div>
	</div>
	<div class="flex-none w-full mt-2 px-2" *ngIf="selectedFrequencyControl.value === frequencyTypesEnum.WEEKLY">
		<div class="flex items-center">
			<span>on</span>
			<div class="inline-block mx-2">
				<mat-form-field appearance="outline" class="mb-2 w-full gap-0">
					<mat-select [formControlName]="formKeysEnum.WeekDay" #siSelectRef5="matSelect">
						<mat-option *ngFor="let item of weekDaysOptions" [value]="item.value">{{ item.description }}</mat-option>
					</mat-select>
					<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef5.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
				</mat-form-field>
			</div>
		</div>
	</div>
</div>
